import React from 'react';
import { PropTypes } from 'prop-types';
import { Route } from 'react-router';

import ErrorBoundary from 'app/components/common/ErrorBoundary';


const ExtendedRoute = ({ component: Component, ...rest }) => {
  const render = props => (
    <ErrorBoundary>
      <Component {...props} />
    </ErrorBoundary>
  );

  return <Route {...rest} render={render} />;
};


ExtendedRoute.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
  ]).isRequired,
};


export default ExtendedRoute;



// WEBPACK FOOTER //
// ./src/app/components/routes/Route/index.jsx